import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { createNotification, getNotifications } from "../../redux/notification/notificationSlice";
import { getUsers } from "../../redux/userSpeaker/userSpeakerSlice";
import Select from "react-select";
import { Row } from "react-bootstrap";
import { formatDate, getImageUrlHelper, truncateText } from "../../helper/helper";
import useDebounce from "../../hook/useDebounce";
import Avatar from "../../components/Avtar/Avatar";
import { getMasterData } from "../../redux/master/masterSlice";
import PaginationHelper from "../../helper/PaginationHelper";


const NotificationLayer = () => {

    const dispatch = useDispatch();

    const { notifications } = useSelector((state) => state.notification);
    const { users = {} } = useSelector((state) => state.speaker);
    const { masterData } = useSelector((state) => state.master);

    const [type, setType] = useState("ALL");
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [userIds, setUserIds] = useState([]);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [action, setAction] = useState("");

    const actionOptions = masterData?.notification?.targets || [];
    const topicsOptions = masterData?.notification?.topics || [];

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [search, setSearch] = useState("");
    const [userSearch, setUserSearch] = useState("");
    const debouncedUserSearch = useDebounce(userSearch, 1000);
    const [entries, setEntries] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const debouncedSearch = useDebounce(search, 1000);

    const filteredNotifications = notifications?.filter((n) =>
        n.title?.toLowerCase().includes(search.toLowerCase())
    );

    const handleImageChange = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (!file.type.startsWith("image/")) {
            toast.error("Only image files are allowed");
            return;
        }

        setImage(file);
        setPreview(URL.createObjectURL(file));
    };

    const totalEntries = filteredNotifications.length;
    const totalPages = Math.ceil(totalEntries / entries);

    const startIndex = (currentPage - 1) * entries;
    const endIndex = startIndex + entries;

    const paginatedNotifications = filteredNotifications.slice(startIndex, endIndex);

    useEffect(() => {
        dispatch(getMasterData());
    }, []);


    const userOptions = users.map((u) => ({
        value: u.id,
        label: `${u.fullName} (${u.email})`
    }));
    useEffect(() => {
        if (type === "SPECIFIC_USER") {
            dispatch(getUsers({ search: debouncedUserSearch }));
        }
    }, [debouncedUserSearch, type]);
    useEffect(() => {
        if (type !== "SPECIFIC_USER") {
            setUserIds([]);
        }
    }, [type]);
    useEffect(() => {
        if (actionOptions.length > 0 && !action) {
            setAction(actionOptions[0]);
        }
    }, [actionOptions]);

    useEffect(() => {
        dispatch(getNotifications({ page, limit, search: debouncedSearch }));
    }, [dispatch, page, limit, debouncedSearch]);

    const handleSubmit = () => {

        if (!type) {
            toast.error("Type is required");
            return;
        }

        if (!title || !title.trim()) {
            toast.error("Title is required");
            return;
        }

        if (title.length > 255) {
            toast.error("Title max 255 characters");
            return;
        }

        if (!body || !body.trim()) {
            toast.error("Message is required");
            return;
        }

        if (body.length > 1000) {
            toast.error("Message max 1000 characters");
            return;
        }

        if (type === "SPECIFIC_USER" && userIds.length === 0) {
            toast.error("Please select at least one user");
            return;
        }
        if (!action) {
            toast.error("Action is required");
            return;
        }
        const formData = new FormData();

        formData.append("types", type);
        formData.append("title", title.trim());
        formData.append("body", body.trim());
        formData.append("target", action);

        if (type === "SPECIFIC_USER") {
            formData.append("userIds", userIds.join(","));
        }

        if (image) {
            formData.append("image", image);
        }

        dispatch(createNotification(formData))
            .unwrap()
            .then((res) => {
                toast.success(res?.message || "Notification sent");

                setType("ALL");
                setTitle("");
                setBody("");
                setUserIds([]);
                setImage(null);
                setPreview(null);

                dispatch(getNotifications({ page, limit, search: debouncedSearch }));

                document.querySelector("#notificationModal .btn-close")?.click();
            })
            .catch((err) => {
                toast.error(
                    err?.response?.data?.message ||
                    err?.message ||
                    "Failed"
                );
            });
    };

    return (
        <>

            <div className="card h-100 p-0 radius-12">


                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">

                    <div className="d-flex align-items-center flex-wrap gap-3">

                        <span className="text-md fw-medium text-secondary-light">
                            Show
                        </span>

                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={entries}
                            onChange={(e) => {
                                setEntries(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                        </select>

                        <form className="navbar-search">

                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />

                            <Icon icon="ion:search-outline" className="icon" />

                        </form>

                    </div>

                    <button
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        data-bs-toggle="modal"
                        data-bs-target="#notificationModal"
                    >
                        <Icon icon="ic:baseline-plus" />
                        Send Notification
                    </button>

                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table bordered-table sm-table mb-0">

                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Banner</th>
                                    <th>Title</th>
                                    <th>Message</th>
                                    {/* <th>Status</th> */}
                                    <th>Created At</th>
                                    <th>Created By</th>
                                </tr>
                            </thead>

                            <tbody>

                                {paginatedNotifications.map((n, i) => (
                                    <tr key={n.id}>
                                        <td>{i + 1}</td>
                                        <td>

                                            <Avatar
                                                name={n.title}
                                                image={n.image}
                                                uniqueKey={n.id}
                                                size={28}
                                            />

                                        </td>

                                        <td>{truncateText(n.title, 30)}</td>
                                        <td>{truncateText(n.body, 30)}</td>
                                        {/* <td>{n.status}</td> */}
                                        <td>{formatDate(n.createdAt)}</td>
                                        <td>{truncateText(n?.createdByUser?.fullName)}</td>
                                    </tr>
                                ))}

                            </tbody>

                        </table>
                    </div>
                    {/* PAGINATION */}
                    <PaginationHelper
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        totalItems={totalEntries}
                        pageSize={entries}
                    />
                </div>

            </div>

            {/* MODAL */}

            <div className="modal fade" id="notificationModal">

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content">

                        <div className="modal-header">

                            <h5>Send Notification</h5>

                            <button className="btn-close" data-bs-dismiss="modal" />

                        </div>

                        <div className="modal-body">

                            <div className="row">

                                <div className="col-md-6 mb-3">
                                    <label>
                                        Target <span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className="form-control"
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                    >
                                        {topicsOptions.map((item) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>
                                        Action <span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className="form-control"
                                        value={action}
                                        onChange={(e) => setAction(e.target.value)}
                                    >
                                        {/* <option value="">Select Action</option> */}
                                        {actionOptions.map((item) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>
                                        Users {type === "SPECIFIC_USER" && <span className="text-danger">*</span>}
                                    </label>

                                    <Select
                                        isMulti
                                        isDisabled={type !== "SPECIFIC_USER"}
                                        options={userOptions}

                                        value={selectedUsers}

                                        onChange={(selected) => {
                                            setSelectedUsers(selected || []);
                                            setUserIds(selected ? selected.map(s => s.value) : []);
                                        }}

                                        onInputChange={(inputValue) => {
                                            setUserSearch(inputValue);
                                        }}

                                        onMenuOpen={() => {
                                            if (type === "SPECIFIC_USER" && !users.length) {
                                                dispatch(getUsers({ search: "" }));
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>
                                        Title <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        className="form-control"
                                        maxLength={255}
                                        placeholder="Enter title"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />

                                </div>

                                <div className="col-md-6 mb-3">
                                    <label>
                                        Message <span className="text-danger">* </span>
                                        <small className="fst-italic">Max 255 chars</small>

                                    </label>

                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        maxLength={255}
                                        placeholder="Enter message"
                                        value={body}
                                        onChange={(e) => setBody(e.target.value)}
                                    />

                                </div>
                                <div className="col-md-6 mb-3">
                                    <label>
                                        Banner <small className="fst-italic">(16:9 optional)</small>
                                    </label>

                                    <div className="upload-image-wrapper d-flex align-items-center gap-3">

                                        <label
                                            htmlFor="upload-file"
                                            className="upload-file border radius-8 border-dashed d-flex align-items-center justify-content-center"
                                        >
                                            {preview ? (
                                                <img
                                                    src={preview}
                                                    alt="preview"
                                                    className="w-100 h-100 object-fit-cover"
                                                />
                                            ) : (
                                                <div className="text-center">
                                                    <Icon icon="solar:camera-outline" width="24" />
                                                    <div className="text-xs">Upload</div>
                                                </div>
                                            )}
                                        </label>

                                        <input
                                            id="upload-file"
                                            type="file"
                                            hidden
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />

                                    </div>
                                </div>

                            </div>

                            <div className="text-end">

                                <button
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    Send
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>

    );

};

export default NotificationLayer;